module.exports = __webpack_public_path__ + "static/media/class (12).cddc4e6a.webp";